import request from '@/utils/request';
//  创建产品
export function api_insert(params) {
  return request.post('/bussbank/supplyFinancialProduct/insert', params);
}
// 更新产品
export function api_update(params) {
  return request.post('/bussbank/supplyFinancialProduct/update', params);
}
// 分页查询产品列表
export function api_getPageList(params) {
  return request({
    url: '/bussbank/supplyFinancialProduct/getPageList',
    method: 'get',
    params
  });
}
// 切换产品状态（暂停/激活）
export function api_updateStatus(params) {
  return request({
    url: '/bussbank/supplyFinancialProduct/updateStatus',
    method: 'get',
    params
  });
}
// 删除产品
export function api_delete(params) {
  return request({
    url: '/bussbank/supplyFinancialProduct/delete',
    method: 'get',
    params
  });
}
// 分页查询贷款申请列表
export function api_getLoanApplicationList(params) {
  return request({
    url: '/bussbank/supplyFinancialProduct/getLoanApplicationList',
    method: 'get',
    params
  });
}
// 贷款申请列表分页查询
export function api_getLoanApplicationPageList(params) {
  return request({
    url: '/bussbank/supplyLoanApply/getPageList',
    method: 'get',
    params
  });
}
// 贷款审批
export function api_approval(params) {
  return request.post('/bussbank/supplyLoanApply/approval', params);
}
